import demandsSaga from './demandsSaga';

export default demandsSaga;
